import React from 'react';
import Modal from 'react-modal';
import { AiOutlineClose } from 'react-icons/ai';

const AdvancedSearchModal = ({
  isOpen,
  onRequestClose,
  filteredStudents,
  searchDistrict,
  setSearchDistrict,
  searchCity,
  setSearchCity,
  searchCollege,
  setSearchCollege,
  setFilteredStudents,
  studentsData,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Search Filters"
      className="mx-auto my-10 mt-[100px] max-w-md bg-white rounded-lg shadow-lg"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="sticky top-0 z-10 bg-white px-6 py-4 border-b">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold">Search Filters</h2>
          <button onClick={onRequestClose}>
            <AiOutlineClose className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </button>
        </div>
      </div>

      <div className="p-6 space-y-4">
        <div className="flex flex-col">
          <label htmlFor="district-filter" className="mb-1 font-medium">District</label>
          <select
            id="district-filter"
            className="p-2 border rounded"
            value={searchDistrict}
            onChange={(e) => {
              setSearchDistrict(e.target.value);
              setSearchCity('');
              setSearchCollege('');
            }}
          >
            <option value="">Select District</option>
            {Array.from(new Set(filteredStudents.map(student => student.district)))
              .filter(Boolean)
              .map(district => (
                <option key={district} value={district}>
                  {district}
                </option>
              ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="city-filter" className="mb-1 font-medium">City</label>
          <select
            id="city-filter"
            className="p-2 border rounded"
            value={searchCity}
            onChange={(e) => {
              setSearchCity(e.target.value);
              setSearchCollege('');
            }}
            disabled={!searchDistrict}
          >
            <option value="">{searchDistrict ? "Select City" : "First select District"}</option>
            {Array.from(new Set(
              filteredStudents
                .filter(student => searchDistrict && student.district?.toLowerCase() === searchDistrict.toLowerCase())
                .map(student => student.city)
            ))
              .filter(Boolean)
              .map(city => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label htmlFor="college-filter" className="mb-1 font-medium">College Name</label>
          <select
            id="college-filter"
            className="p-2 border rounded"
            value={searchCollege}
            onChange={(e) => setSearchCollege(e.target.value)}
            disabled={!searchCity}
          >
            <option value="">{searchCity ? "Select College" : "First select City"}</option>
            {Array.from(new Set(
              filteredStudents
                .filter(student => searchCity && student.city?.toLowerCase() === searchCity.toLowerCase())
                .map(student => student.clg_name)
            ))
              .filter(Boolean)
              .map(college => (
                <option key={college} value={college}>
                  {college}
                </option>
              ))}
          </select>
        </div>

        <div className="flex justify-end pt-4">
          <button
            onClick={() => {
              setSearchDistrict('');
              setSearchCity('');
              setSearchCollege('');
              setFilteredStudents(studentsData);
            }}
            className="px-4 py-2 mr-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Clear
          </button>
          <button
            onClick={() => {
              const filtered = studentsData.filter(student => {
                const districtMatch = !searchDistrict ||
                  student.district?.toLowerCase().includes(searchDistrict.toLowerCase());
                const cityMatch = !searchCity ||
                  student.city?.toLowerCase().includes(searchCity.toLowerCase());
                const collegeMatch = !searchCollege ||
                  student.clg_name?.toLowerCase().includes(searchCollege.toLowerCase());

                return districtMatch && cityMatch && collegeMatch;
              });
              setFilteredStudents(filtered);
              onRequestClose();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Apply
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default AdvancedSearchModal;